<template>
  <ym-popup class="qrcode-popup"
            v-model="visible"
  >
    <div class="qrcode-popup-title" v-html="title"></div>
    <div class="qrcode-popup-line"></div>
    <div class="qrcode-popup-image">
      <img :src="qrcode"
           alt="qrcode"
      />
    </div>
  </ym-popup>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'QrCodePopup',
    components: {
      'ym-popup': Popup,
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      qrcode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
  };
</script>

<style scoped lang="less">
@import '~@/assets/styles/var.less';

.qrcode-popup {
  width: 600px;
  height: 700px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  padding: 126px 63px 0;
  box-sizing: border-box;
  &-title {
    color: #e74933;
    font-size: @font-size-base;
    text-align: center;
    line-height: 40px;
  }
  &-line {
    position: relative;
    border-bottom: 1px solid #f57749;
    margin: 20px 0 67px;
    &:after {
      position: absolute;
      left: 50%;
      margin-left: -12px;
      content: '';
      width: 0;
      border-width: 12px;
      border-style: solid;
      border-color: #f57749 transparent transparent transparent;
    }
  }
  @contact-image-size: 260px;
  &-image {
    width: 474px;
    height: 474px;
    text-align: center;
    img {
      width: @contact-image-size;
      height: @contact-image-size;
      -webkit-touch-callout: none;
      z-index: 9;
    }
  }
}
</style>
